import Papa from 'papaparse';

export interface DailyDataRow {
  datetime: string;
  solar_kwh: number;
  grid_kwh: number;
  ac_kwh: number;
  active_power_kw: number;
  ahu_working_percent: number;
  indoor_temp_c: number;
  outdoor_temp_c: number;
  operation: string;
}

export interface ReportDailyRow {
  Date: string;
  'Outdoor Temp (°C)': number;
  'Baseline AC (kWh)': number;
  'Actual AC (kWh)': number;
  'Autopilot Saving (kWh)': number;
  'Autopilot Saving (%)': number;
  'Solar (kWh)': number;
  'Grid (kWh)': number;
  'Solar Percentage (%)': number;
  'Total (kWh)': number;
}

export interface ReportMonthlyRow {
  MONTH: string;
  DAYS: number;
  'SOLAR (UNITS)': number;
  'GRID (UNITS)': number;
  'TOTAL (kWh)': number;
  'SOLAR (%)': number;
  'BASELINE (UNITS)': number;
  'ACTUAL (UNITS)': number;
  'SAVINGS (UNITS)': number;
  'SAVINGS (%)': number;
}

export const parseCSV = <T>(
  csvContent: string,
  transformHeader?: (header: string) => string
): Promise<T[]> => {
  return new Promise((resolve, reject) => {
    Papa.parse(csvContent, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      transformHeader: transformHeader,
      complete: (results) => {
        resolve(results.data as T[]);
      },
      error: (error) => {
        reject(error);
      },
    });
  });
};

export const loadCSVFile = async (filePath: string): Promise<string> => {
  const response = await fetch(filePath);
  return response.text();
};